<script setup lang="ts">
  import { PageDecorationImage } from '@/shared/ui/components'

  import {
    RolesControlForm,
    rolesControlFormKey,
    RolesControlSearchBar,
    useRolesControlForm,
  } from '@/features/roles-control'

  const route = useRoute('/roles-control')
  const initialSearch = typeof route.query.search === 'string' ? route.query.search : ''

  const rolesControlForm = useRolesControlForm({ initialSearch })
  provide(rolesControlFormKey, rolesControlForm)

  definePage({
    meta: {
      layout: 'baseNew',
      contentManagerRoute: true,
    },
  })

  const { t } = useI18n()

  useHead({
    title: () => t('roles_control_page_title'),
  })
</script>

<template>
  <div class="wide-responsive flex h-full w-full flex-col overflow-hidden">
    <div class="relative flex shrink-0 flex-col gap-4 border-b p-6 pt-8">
      <PageDecorationImage />

      <h1 class="heading-md text-heading! mb-6">
        {{ $t('roles_control_page_title') }}
      </h1>

      <RolesControlSearchBar />
    </div>

    <RolesControlForm class="min-h-0 flex-1" />
  </div>
</template>
